<template>
    <div>
        <modal-app :name="'mercado-livre'">
            <div class="pt-4"><h2 class="text-center">{{!data.error ? "Autenticação realizada com sucesso!" : "Não foi possível autenticar, tente novamente!"}}</h2></div>
            <div class="d-flex justify-content-between p-4">
                <div style="max-width: 28%;">
                    <img style="width: 100%;" :src="$baseUrl+'assets/images/logos/logo-ml.png'" alt="">
                </div>
                <div class="d-flex align-items-center justify-content-center" style="max-width: 28%;">
                    <img v-if="data.error"  @click="showError()" style="width: 60%;" :src="$baseUrl+'assets/images/logos/cancel.png'" alt="">
                    <img
                        v-else style="width: 60%;"
                        :src="$baseUrl+'assets/images/logos/success.png'"
                        alt=""
                    >
                </div>
                <div class="d-flex align-items-center" style="max-width: 28%;">
                    <img style="width: 100%;" :src="company.logo_url" alt="">
                </div>
            </div>
            <div class="p-4 d-flex justify-content-end">
                <button
                type="button"
                class="btn bg-dark mr-2"
                style="color:#fff;"
                @click="closeWindow()"
                >Sair</button>
                <button
                type="button"
                class="btn bg-success"
                style="color:#fff;"
                @click="redirectToHome()"
                >Continuar navegando</button>
            </div>
        </modal-app>
    </div>

</template>

<script>
import { BASE_URL_APP } from '../../http/baseUrl'
import ModalApp from '../ModalApp.vue'

export default {
  components: { ModalApp },
    name: 'Authenticated',
    props: {
        resp:{ type:String, required: true }
    },
    data() {
        return {
            company: this.$root.$children[0].$attrs.company,
            data: JSON.parse(this.resp)
        }
    },
    mounted() {
        setTimeout(()=>{
            this.$root.showModalApp('mercado-livre')
        }, 20)
    },
    methods: {
        showError() {
            alert(this.data.msg)
        },
        closeWindow() {
            window.close();
        },
        redirectToHome() {
            window.location.href = BASE_URL_APP;
        }
    }

}
</script>
